<template>
  <section class="knowledge-centre">
    <div class="knowledge-centre-inner">
      <h2>全球电子商务知识中心</h2>
      <div class="content">
        <div class="calendar">
          <router-link to="/scheduler" class="explore">
            <div class="calendar-left">
              <h3>日历</h3>
              <h2>2025年全球电子商务日历</h2>
              <a class="explore" @click="toDetail">学习更多</a>
            </div>
            <div class="calendar-right">
              <img
                src="../../assets/knowledge-center/calendar-2025.png"
                alt=""
              />
            </div>
          </router-link>
          <!-- 修改为路由跳转 -->
        </div>
        <!-- <div class="report">
          <img
            src="../../assets/knowledge-center/headers-website-1.png"
            alt=""
          />
          <div class="box">
            <h3>汇报</h3>
            <h2>2024年黑色星期五网络星期一报道</h2>
            <a class="explore">下载</a>
          </div>
        </div>
        <div class="demand">
          <img
            src="../../assets/knowledge-center/Digital-Marketing-Tips-for-Holidays.png"
            alt=""
          />
          <div class="box">
            <h3>需求生成</h3>
            <h2>国际假日旺季的数字营销技巧</h2>
            <a class="explore">学习更多</a>
          </div>
        </div> -->
      </div>
      <div class="card-body">
        <div class="tabs">
          <a class="btn" @click="tabListShow = !tabListShow">
            类别
            <img
              v-if="tabListShow == true"
              src="../../assets/knowledge-center/icon-up.svg"
              alt=""
            />
            <img
              v-else
              src="../../assets/knowledge-center/icon-down.svg"
              alt=""
            />
          </a>
          <ul :class="{ action: tabListShow }" @click="tabChange">
            <li><a :class="{ action: tabTypeAction === '全部' }">全部</a></li>
            <li>
              <a :class="{ action: tabTypeAction === '网络研讨会' }"
                >网络研讨会
              </a>
            </li>
            <li><a :class="{ action: tabTypeAction === '汇报' }">汇报</a></li>
            <li><a :class="{ action: tabTypeAction === '指导' }">指导</a></li>
            <li><a :class="{ action: tabTypeAction === '播客' }">播客</a></li>
            <li>
              <a :class="{ action: tabTypeAction === '白皮书' }">白皮书</a>
            </li>
            <li><a :class="{ action: tabTypeAction === '日历' }">日历</a></li>
            <li><a :class="{ action: tabTypeAction === '文章' }">文章</a></li>
            <li>
              <a :class="{ action: tabTypeAction === '需求生成' }">需求生成</a>
            </li>
          </ul>
        </div>
        <div class="card-list">
          <div class="card-item" v-for="item in cardList" :key="item.id">
            <img :src="item.imageUrl" alt="" />
            <div class="card-item-body">
              <div class="type">{{ item.type }}</div>
              <h3>{{ item.title }}</h3>
              <p>{{ item.text }}</p>
              <a class="explore" @click="toDetail">学习更多</a>
            </div>
          </div>
        </div>
        <div class="load-more">
          <a @click="onToLoadMoreData" v-if="!moreDataLoading">
            <img src="../../assets/knowledge-center/Plus-icon.svg" alt="" />
            <span>加载更多</span>
          </a>
          <img
            v-else
            class="load-icon"
            src="../../assets/knowledge-center/icon-load.svg"
            alt=""
          />
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: '',
  data() {
    return {
      tabListShow: false,
      tabTypeAction: '全部',
      moreDataLoading: false,
      cardAllList: [
        {
          id: 1,
          type: '需求生成',
          title: '面向全球受众的数字营销5个技巧和最佳实践',
          text: '对于在全球销售的商家来说，在不同市场开展有效的数字营销活动可能是一项挑战。全球电子商务数字营销团队编制了一套全面的技巧和最佳实践，以帮助企业了解具体情况并推动全球不同地区的需求。这些见解来自他们在25个市场与全球电子客户合作的丰富经验',
          imageUrl: require('../../assets/knowledge-center/card/shutterstock_1940399131-768x505.jpg')
        },
        {
          id: 2,
          type: '文章',
          title: '电子商务市场聚焦波兰',
          text: '波兰是欧洲发展最快的电子商务市场之一。了解更多关于这个新兴市场的信息，了解其电子商务趋势和当地消费者的在线购物偏好',
          imageUrl: require('../../assets/knowledge-center/card/banner-poland-1-768x225.png')
        },
        {
          id: 3,
          type: '汇报',
          title: '澳大利亚跨境电商购物者调查',
          text: '探索澳大利亚电子商务购物者在国际上的购物倾向我们对1000名澳大利亚跨境在线消费者进行的全面调查为塑造他们购买习惯的因素提供了宝贵的见解',
          imageUrl: require('../../assets/knowledge-center/card/AU-2.jpg-768x402.webp')
        },
        {
          id: 4,
          type: '日历',
          title: '2024年全球电子商务日历',
          text: '2024年全球电子商务日历包含全球最受欢迎的电子商务购物活动和假期，以及有用的信息，可帮助您提前计划所有全球在线促销活动',
          imageUrl: require('../../assets/knowledge-center/card/calendar-2024.jpg-768x402.webp')
        },
        {
          id: 5,
          type: '网络研讨会',
          title: '基于数据的模型，推动国际数字地面通信增长战略和盈利能力',
          text: '数字企业总裁乔纳森·格雷勒详细介绍了大品牌如何将其数字优先策略扩展到全球市场，并在其三个主要品牌bcbg motherty和豌豆荚的网店上实施了先进的本地化',
          imageUrl: require('../../assets/knowledge-center/card/marquee-brands-1-1-768x326.png')
        },
        {
          id: 6,
          type: '指导',
          title: '为无协议脱欧做准备，保持欧盟电子商务转化率和客户满意度',
          text: '英国的过渡期将于2020年12月31日结束，但迄今为止尚未达成任何协议。对于脱欧后与欧盟进行贸易的英国商人，这里有一些见解和建议',
          imageUrl: require('../../assets/knowledge-center/card/Brexit_1024X768-1-768x576.png')
        },
        {
          id: 7,
          type: '播客',
          title: '跨境解决方案的迫切需要',
          text: '本期《up next in commerce》以全球电子公司北美首席执行官马修·梅里埃为特色，他分享了数据驱动的见解，了解国际电子商务零售商的成功原因以及发展全球在线业务的方法',
          imageUrl: require('../../assets/knowledge-center/card/shutterstock_554446720-768x509.jpg')
        }
      ]
    }
  },
  computed: {
    cardList() {
      return this.cardAllList.filter(
        item =>
          this.tabTypeAction === '全部' || item.type === this.tabTypeAction
      )
    }
  },
  methods: {
    toDetail(id) {
      this.$router.push({
        name: 'KnowledgeDetail'
        // query: { id: id }
      })
    },
    tabChange(e) {
      this.tabTypeAction = e.target.innerText
    },
    onToLoadMoreData() {
      this.moreDataLoading = true
      setTimeout(() => {
        this.moreDataLoading = false
      }, 3000)
    }
  }
}
</script>

<style scoped lang="less">
.knowledge-centre {
  background-color: #fbfbfc;
  padding: 0 5%;
  border-bottom: 1px solid #000000;
  .knowledge-centre-inner {
    width: 1140px;
    margin: 0 auto;
    & > h2 {
      padding: 100px 0;
      text-align: center;
      font-size: 48px;
    }
    .content {
      width: 1140px;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      row-gap: 40px;
      .calendar,
      .report,
      .demand {
        box-shadow: 0px 0px 15px 0px rgba(0, 0, 0, 0.15);
      }
      .calendar {
        width: 100%;
        height: 370px;
        display: flex;
        .calendar-left {
          width: 339px;
          padding: 30px;
          display: flex;
          flex-direction: column;
          justify-content: center;
          gap: 20px;
        }
        .calendar-right {
          width: 741px;
          img {
            width: 100%;
            height: 100%;
          }
        }
      }
      .report,
      .demand {
        width: 550px;
        height: 398px;
        img {
          width: 100%;
          height: 180px;
          object-fit: cover;
        }
        .box {
          height: 158px;
          padding: 30px;
          display: flex;
          flex-direction: column;
          gap: 20px;
          h2 {
            font-size: 26px;
          }
          .explore {
            margin-top: auto;
          }
        }
      }
      h3 {
        font-size: 16px;
        font-weight: 400;
        color: #2f5ad9;
      }
      h2 {
        font-size: 32px;
      }
    }
    .card-body {
      padding: 60px 0 80px;
      .tabs {
        .btn {
          display: block;
          font-size: 20px;
          color: #bfc0c1;
          padding: 5px 8px;
          img {
            width: 10px;
            height: 15px;
          }
        }
        ul {
          display: flex;
          align-items: start;
          gap: 8px;
          max-height: 0;
          overflow: hidden;
          transition: all 0.5s;
          a {
            display: block;
            padding: 8px;
            font-size: 16px;
            &:hover {
              color: #2f5ad9;
            }
          }
          .action {
            color: #2f5ad9;
          }
        }
        .action {
          max-height: 38px;
        }
      }
      .card-list {
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        grid-gap: 20px;
        padding-top: 30px;
        .card-item {
          box-shadow: 0px 0px 15px 0px rgba(0, 0, 0, 0.15);
          display: flex;
          flex-direction: column;
          img {
            width: 100%;
            height: 200px;
            object-fit: cover;
            object-position: center center;
          }
          .card-item-body {
            flex: 1;
            padding: 20px 50px 30px 30px;
            display: flex;
            flex-direction: column;
            gap: 20px;
            .type {
              color: #2f5ad9;
            }
            h3 {
              font-size: 26px;
            }
            .explore {
              margin-top: auto;
            }
          }
        }
      }
      .load-more {
        margin-top: 30px;
        display: flex;
        justify-content: center;
        a {
          display: flex;
          align-items: center;
          padding: 16px 40px;
          img {
            margin-right: 6px;
          }
          span {
            font-size: 18px;
            font-weight: 700;
            color: #2a2c2f;
          }
        }
        .load-icon {
          width: 30px;
          height: 30px;
        }
      }
    }
    .explore {
      font-size: 16px;
      font-weight: 700;
      transition: all 0.5s;
      display: flex;
      color: #2a2c2f;
      align-items: center;
      &::after {
        content: url('../../assets/knowledge-center/icon-right.svg');
        display: block;
        width: 1em;
        transform: scale(0.6);
        margin-left: 10px;
      }
      &:hover {
        transform: translateX(6px);
        color: #2f5ad9;
      }
    }
  }
}
</style>
